import * as yup from 'yup';

export const signupSchema = yup.object({
  username: yup.string().required('名前は必須項目です'),
  email: yup.string().email('メール形式が正しくありません').required('必須項目です'),
  password: yup.string().min(6, '6文字以上で入力してください').required('必須項目です'),
});

export const loginSchema = yup.object({
  email: yup.string().email('メール形式が正しくありません').required('メールは必須です'),
  password: yup.string().min(6, '6文字以上で入力してください').required('パスワードは必須です'),
});

export const profileSchema = yup.object({
  name: yup.string().required('名前は必須です'),
  birthday: yup.date(),
});
